/* 常用时间函数 */
/* 使用类，不易与其他名称混合，并且有提示该函数是时间函数作用 */
/* import moment from 'moment' */
/* moment.isValid() */

class Moment {
	/* 不足10，添加0 */
	static zeroize(num: number | string) {
		return Number(num) < 10 ? `0${num}` : num;
	}
	/* 检查日期合法性 */
	static isValid(day: string | number) {
		return new Date(day).getTime().toString() !== 'Invalid Date';
	}
	/* 比较两个日期先后 */
	static isBeforeDay(firstDay: string, secondDay: string | number) {
		if (this.isValid(firstDay) && this.isValid(secondDay)) {
			return new Date(firstDay).getTime() < new Date(secondDay).getTime();
		}
	}
	/* 检查是否日期在输入日期之后 */
	static isBefore(day: string) {
		if (this.isValid(day) && day) {
			return new Date().getTime() > new Date(day).getTime();
		}
	}
	/* 检查是否日期在当前日期之后 */
	static isBeforeToday(day: string) {
		if (this.isValid(day) && day) {
			if (new Date(day).getDate() === new Date().getDate()) {
				return !(
					Math.abs(new Date().getTime() - new Date(day).getTime()) < 86400000
				);
			}
			return this.isBefore(day);
		}
	}

	/* 将时间格式化成(xx-xx-xx) 主要用于element-ui时间控件*/
	static localDay(dayTime: string | number) {
		let dateTime = new Date(dayTime);
		return `${dateTime.getFullYear()}-${this.zeroize(
			dateTime.getMonth() + 1
		)}-${this.zeroize(dateTime.getDate())}`;
	}
	/* 获取距离今天多少天是什么日期 */
	static getDayFromNow(num: number) {
		let oneDay = 86400000;
		let today = new Date().getTime();
		return this.localDay(today + (num ? oneDay * num : 0));
	}
	/* 获取距离输入日期多少天是什么日期 */
	static getDayFromDate(date: Date | string, num: number) {
		let oneDay = 86400000;
		let today = new Date(date).getTime();
		return this.localDay(today + (num ? oneDay * num : 0));
	}

	/* 格式化 Date 对象到相应格式 */

	static formatDayTo(date: Date, fmt: string) {
		date = typeof date === 'string' ? new Date(Number(date)) : date;

		let o = {
			'M+': date.getMonth() + 1, // 月份
			'd+': date.getDate(), // 日
			'h+': date.getHours(), // 小时
			'm+': date.getMinutes(), // 分
			's+': date.getSeconds(), // 秒
			'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
			['S']: date.getMilliseconds(), // 毫秒
		};
		if (/(y+)/.test(fmt)) {
			fmt = fmt.replace(
				RegExp.$1,
				(date.getFullYear() + '').substr(4 - RegExp.$1.length)
			);
		}
		for (let k in o) {
			if (new RegExp('(' + k + ')').test(fmt)) {
				fmt = fmt.replace(
					RegExp.$1,
					RegExp.$1.length === 1
						? o[k]
						: ('00' + o[k]).substr(('' + o[k]).length)
				);
			}
		}
		return fmt;
	}
}

export default Moment;
